"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipToObj = void 0;

/**
 * Create an object from two arrays, one containing keys, the other values.
 * Bost arrays will be trimmed to the smallest length.
 *
 * @param  {Array}  keys    Array with keys
 * @param  {Array}  values  Array with values
 *
 * @return {Object}
 *
 * @tag Array
 * @signature ( keys: Array ) => ( values: Array ): Object
 *
 * @example
 * zipToObj( [ a, b ] )( [ 1, 2 ] ) // => { a: 1, b: 2 }
 * zipToObj( [ a ] )( [ 1, 2 ] ) // => { a: 1 }
 */
var zipToObj = function zipToObj(keys) {
  return function (values) {
    var result = {};
    var length = Math.min(keys.length, values.length);

    for (var i = 0; i < length; i++) {
      result[keys[i]] = values[i];
    }

    return result;
  };
};

exports.zipToObj = zipToObj;